import { Injectable } from "@angular/core";
import { BaseService } from "../../core";
import { environment } from "environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { TopicoResponse } from "app/shared/models/ei-models/newsletter/response/topico.response";
import { NewsletterResponse } from "app/shared/models/ei-models/newsletter/response/newsletter.response";
import { NewsletterVisualizarResponse } from "app/shared/models/ei-models/newsletter/response/newsletter-visualizar.response";
import { NewsletterRequest } from "app/shared/models/ei-models/newsletter/request/newsletter.request";

@Injectable({ providedIn: 'root' })
export class NewsletterService extends BaseService{
  private controllerEndpoint = environment.urlEdducaImobApi.concat('EdducaImobCore/Newsletter/');

  constructor(private httpClient: HttpClient) {
    super();
  }

  listar(): Observable<Array<NewsletterResponse>> {
    return this.httpClient.get<Array<NewsletterResponse>>
        (this.controllerEndpoint.concat('ListarTodos'), { headers: this.getHeader(true) });
  }

  listarTopicos(): Observable<Array<TopicoResponse>> {
    return this.httpClient.get<Array<TopicoResponse>>
        (this.controllerEndpoint.concat('ListarTopicos'), { headers: this.getHeader(true) });
  }

  criarNewsletter(request: NewsletterRequest): Observable<void> {
    return this.httpClient.post<void>
      (this.controllerEndpoint.concat('CriarNewsletter'), request, { headers: this.getHeader(true) });
  }
  
  /**
   * Obtém uma newsletter por ID
   * @param idNewsletter ID da newsletter
   * @param usuarioId ID do usuário (opcional, para gamificação)
   */
  obtemNewsletterPorId(idNewsletter: number, usuarioId?: number): Observable<NewsletterVisualizarResponse> {
    let url = this.controllerEndpoint.concat('ObtemNewsletterPorId/' + idNewsletter);
    if (usuarioId) {
      url += `?usuarioId=${usuarioId}`;
    }
    return this.httpClient.get<NewsletterVisualizarResponse>(url, { headers: this.getHeader(true) });
  }
  
}